import { configureStore } from "@reduxjs/toolkit";
import towerReducer from "./slices/towerSlice";

// Add logging middleware
const logger = (store) => (next) => (action) => {
  console.log("Dispatching:", action);
  const result = next(action);
  console.log("Next State:", store.getState());
  return result;
};

export const store = configureStore({
  reducer: {
    tower: towerReducer,
  },
  middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(logger),
  devTools: process.env.NODE_ENV !== "production",
});

// Log initial state
console.log("Initial store state:", store.getState());
